// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-2iHVW","list":"list-2rzgX","item":"item-1VpGY","item_gone":"item_gone-BrfOb"};